import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { SvgMatType } from 'src/app/constants/icons';
import { BasePaths } from 'src/app/constants/routes';

import { SessionService } from 'src/app/services/storage/session.service';

import { Session } from 'src/app/models/session';
import { Router } from '@angular/router';
// import { MatSlideToggleChange } from '@angular/material/slide-toggle';
// import { StyleService } from 'src/app/services/styles.service';

@Component({
    selector: 'mwp-header-login',
    templateUrl: './header-login.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderLoginComponent implements OnInit {
    public route = BasePaths;
    public linkHome: string;
    public linkBrokers: string;
    public linkCounselors: string;
    public linkAdministrators: string;
    public operatingMode: string;
    public memberLink: string;
    public isLoggedIn: boolean;
    public isFirstResponder: boolean;
    public isDarkMode: boolean;
    public isVersionError: boolean;

    public svgType = SvgMatType;

    constructor(
        private sessionService: SessionService,
        //private styleService: StyleService,
        private router: Router,
    ) {
    }

    ngOnInit() {
        this.sessionService.$Session.subscribe((session: Session) => {
            if (!this.operatingMode && session.operatingMode) {
                this.operatingMode = session.operatingMode.operatingMode;
                this.linkHome = session.operatingMode.linkHome;
                this.linkAdministrators = session.operatingMode.linkAdministrators;
                this.linkBrokers = session.operatingMode.linkBrokers;
            }

            this.isDarkMode = session.isDarkMode;
            this.isLoggedIn = session.isLoggedIn;
            if (session.isFirstResponder) {
                this.memberLink = `${BasePaths.FirstResponders}/${session.firstResponderComCode}`;
                this.isFirstResponder = true;
            } else {
                this.memberLink = BasePaths.Members;
            }

            this.linkCounselors = BasePaths.Counselors;

            this.isVersionError = session.isVersionIncompatible;
        });
    }

    // public onDarkModeChange(event: MatSlideToggleChange): void {
    //     this.styleService.setDarkMode(event.checked);
    // }

    public isHeaderLinkActive(linkeURL: string): boolean {
        return this.router.url.startsWith(linkeURL);
    }

    public navigateToURL(linkeURL: string): void { 
        this.router.navigateByUrl(linkeURL);
    }

    public navigateToExternalURL(url: string): void {
        window.location.href = url;
    }

    public closeFAQs() {
        this.sessionService.session.isFaqActive = false;
        this.sessionService.setSession();
    }
}